import React, { useContext, useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faVolumeHigh,
  faVolumeMute,
  faBars,
  faSignInAlt,
  faChevronLeft,
  faSignOutAlt
} from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";

import StateContext from "../StateContext";
import DispatchContext from "../DispatchContext";
import Menu from "./Menu";
import Login from "./Login";

function Nav() {
  const appState = useContext(StateContext);
  const dispatch = useContext(DispatchContext);
  const location = useLocation();
  const navigate = useNavigate();

  const isInfoPage = ["/about", "/terms", "/privacy"].includes(location.pathname);

  const toggleMuted = () => {
    dispatch({ type: "toggleMute" });
  };

  const handleTray = () => {
    if (appState.isTrayVisible === false) {
      dispatch({ type: "setTrayVisible", value: true });
    } else {
      if (appState.trayContent !== Menu) {
        dispatch({ type: "setTrayContent", value: Menu });
      } else {
        dispatch({ type: "setTrayVisible", value: false });
      }
    }
  };

  const handleLogin = () => {
    dispatch({ type: "setTrayContent", value: Login });
    dispatch({ type: "setTrayVisible", value: true });
  };

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
    dispatch({ type: "userLoggedOut" });
    dispatch({ type: "setTrayContent", value: Login });
    dispatch({ type: "setTrayVisible", value: true });
  };

  const handleBack = () => {
    navigate("/");
  };

  return (
    <nav className={`nav ${isInfoPage ? "back" : ""}`}>
      <ul className="icons">
        <li className="hamburger">
          {isInfoPage ? (
            <a href="#!" onClick={handleBack}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </a>
          ) : (
            <a href="#!" onClick={handleTray}>
              <FontAwesomeIcon icon={faBars} />
            </a>
          )}
        </li>
        <li className="empty"></li>
        <li className="notification">
          {!appState.isTrayVisible && appState.isLoggedIn && (
            <img src="/assets/img/logo-aleph.svg" alt="Aleph" />
          )}
        </li>
        <li className="volume">
          <a onClick={toggleMuted}>
            <FontAwesomeIcon
              icon={appState.muted ? faVolumeHigh : faVolumeMute}
            />
          </a>
        </li>
        <li className="aleph-logo">
          <a href="https://alephix.ro" target="_blank" rel="noopener noreferrer">
            <img src="/assets/img/Aleph Logo.svg" alt="Aleph" style={{ width: '20px', height: '20px' }} />
          </a>
        </li>
        {appState.isLoggedIn ? (
          <li className="logout">
            <a onClick={handleLogout} title="Deconectare">
              <FontAwesomeIcon icon={faSignOutAlt} />
            </a>
          </li>
        ) : (
          <li className="login">
            <a onClick={handleLogin} title="Autentificare">
              <FontAwesomeIcon icon={faSignInAlt} />
            </a>
          </li>
        )}
      </ul>
    </nav>
  );
}

export default Nav;
